import { useNavigate } from 'react-router';

import { PageWrapper } from 'src/components/PageWrapper';
import { APP_ROUTES } from 'src/constants/routes';
import { isEmbeddedPlatform } from 'src/features/config/AppEnvironmentDetector/utils';
import { ErrorInfo } from 'src/pages/teams/_components/AuthErrorView/ErrorInfo';

import { Illustration404 } from '@/components/Illustration';

export const NotFound = () => {
  const navigate = useNavigate();

  if (window.location.pathname === '/') {
    return null;
  }

  return (
    <PageWrapper darkBackground={isEmbeddedPlatform()}>
      <div className="flex flex-1 flex-col items-center justify-center gap-12">
        <ErrorInfo
          description="We couldn’t find what you were looking for."
          title="Not Found"
          onClose={() => navigate(APP_ROUTES.HOME, { replace: true })}
        >
          <Illustration404 className="max-w-480" />
        </ErrorInfo>
      </div>
    </PageWrapper>
  );
};
